import {
    Row, Col, Typography, Button, Divider,
    Form, Input
} from 'antd';
import Icon from '@ant-design/icons';
import { FaCog } from 'react-icons/fa';
import { useParams } from 'react-router-dom';

import { colFull, colInputs8 } from './GridStyle';

import LayoutDashboard from './../../../../../layout/LayoutAdmin';

import { Loading } from '../../../../../components/Loading';
import { useCertidoesAddOrUpdate } from './useAddOrUpdate';

const { Text, Title, Link } = Typography;
const IconCogs = (props: any) => (<Icon {...props} component={FaCog} ></Icon>);

const CertidoesCongelamentoAddOrUpdate = () => {

    let { id } = useParams();

    const {
        loading,
        estaEditando,
        navigate,
        refForm,
        onChangeInputNumberNumero,
        onChangeInputFormatMoney,
        submitBotaoEditar,
        submitBotaoSalvar,
        onChangeInputNumberNumeroCusto,
    } = useCertidoesAddOrUpdate({ id })

    return (
        <LayoutDashboard>
            <Loading

                loading={loading}
            >
                <Row>
                    <Col {...colFull}>
                        <Title level={4}>
                            <IconCogs style={{ fontSize: 23, marginRight: 10 }} />
                            {`${estaEditando ? 'Editar' : 'Adicionar'} Certidão`}
                        </Title>
                        <div
                            style={{
                                display: 'flex'
                            }}
                        >
                            <Link
                                // href="#"
                                onClick={() => [
                                    navigate('/congelamento-cnpj/certidoes')
                                ]}
                                style={{
                                    marginRight: 5
                                }}
                            // target="_blank"
                            >
                                <Text
                                    type='secondary' underline
                                >Certidões</Text>
                            </Link>

                            <Text
                                style={{
                                    marginRight: 5
                                }} type='secondary'
                            >/</Text>

                            <Text style={{
                                marginRight: 5
                            }}>{`${estaEditando ? 'Editar' : 'Adicionar'}`}</Text>
                        </div>
                        <Divider />
                    </Col>
                </Row>

                <Form
                    ref={refForm}
                    name="adicionarUsuario"
                    layout="vertical"
                    // onFieldsChange={onFieldsChange}
                    initialValues={{
                        remember: true,
                    }}
                    // onFinish={onFinish}
                    // onFinishFailed={() => { }}
                    autoComplete="off"
                >
                    <Row>
                        <Col {...colInputs8}>
                            <Form.Item
                                style={{
                                    margin: 5
                                }}
                                name="idItem"
                                label="id Item"
                                rules={[
                                    {
                                        required: true,
                                        message: 'Por favor, digite o id item.',
                                    },
                                ]}
                            >
                                <Input
                                    autoComplete="off"
                                    placeholder="5"
                                    onChange={onChangeInputNumberNumero}
                                />
                            </Form.Item>
                        </Col>
                        <Col {...colInputs8}>
                            <Form.Item
                                style={{
                                    margin: 5
                                }}
                                name="nome"
                                label="Nome"
                                rules={[
                                    {
                                        required: true,
                                        message: 'Por favor, digite o nome.',
                                    },
                                ]}
                            >
                                <Input autoComplete="off" placeholder="CNAI" />
                            </Form.Item>
                        </Col>
                        <Col {...colInputs8}>
                            <Form.Item
                                style={{
                                    margin: 5
                                }}
                                name="sigla"
                                label="Sigla"
                                rules={[
                                    {
                                        required: true,
                                        message: 'Por favor, digite a sigla.',
                                    },
                                ]}
                            >
                                <Input autoComplete="off" placeholder="cnai" />
                            </Form.Item>
                        </Col>

                        <Col {...colInputs8}>
                            <Form.Item
                                style={{
                                    margin: 5
                                }}
                                name="custo"
                                label="Custo"
                                rules={[
                                    {
                                        required: true,
                                        message: 'Por favor, digite o custo.',
                                    },
                                ]}
                            >
                                <Input
                                    autoComplete="off"
                                    placeholder="0.55"
                                    // onChange={onChangeInputFormatMoney}
                                    onChange={onChangeInputNumberNumeroCusto}
                                />
                            </Form.Item>
                        </Col>
                        <Col {...colFull}>
                            <div className="botaoSalvarStep" style={{
                                flexDirection: 'row',
                                display: 'flex',
                                justifyContent: 'flex-end',
                                // background: 'red'
                            }}>
                                <Button
                                    key="volatrForm"
                                    // type="primary"
                                    style={{
                                        marginTop: 20
                                    }}
                                    onClick={() => {
                                        navigate('/congelamento-cnpj/certidoes')
                                    }}
                                >
                                    {"Voltar"}
                                </Button>
                                <Button
                                    key="submit"
                                    type="primary"
                                    style={{
                                        marginLeft: 5,
                                        marginTop: 20,
                                    }}
                                    onClick={() => {
                                        estaEditando ?
                                            submitBotaoEditar(id ? id : 'criar')
                                            :
                                            submitBotaoSalvar()
                                    }}
                                >
                                    {"Salvar"}
                                </Button>
                            </div>
                        </Col>
                    </Row>
                </Form>
            </Loading>

        </LayoutDashboard >
    );
}

export default CertidoesCongelamentoAddOrUpdate;
